export const GOODPAY_MERCHANT = '15';

export const goodpayVerify = (param?: string) => {
  if (param) {
    return `/${GOODPAY_MERCHANT}/verify/${param}` as const;
  }
  return 'verify/:id' as const;
};

export const goodpayVerifySuccess = (param?: string) => {
  if (param) {
    return `/${GOODPAY_MERCHANT}/verify/success/${param}` as const;
  }
  return 'verify/success/:id' as const;
};

export const goodpayVerifyFailed = (param?: string) => {
  if (param) {
    return `/${GOODPAY_MERCHANT}/verify/failed/${param}` as const;
  }
  return 'verify/failed/:id' as const;
};

export const goodpayPay = (param?: string) => {
  if (param) {
    return `/${GOODPAY_MERCHANT}/pay/${param}`;
  }
  return 'pay/:id' as const;
};

export const goodpayPaySuccess = (param?: string) => {
  if (param) {
    return `/${GOODPAY_MERCHANT}/pay/success/${param}` as const;
  }
  return 'pay/success/:id' as const;
};

export const goodpayPayFailed = (param?: string) => {
  if (param) {
    return `/${GOODPAY_MERCHANT}/pay/failed/${param}` as const;
  }
  return 'pay/failed/:id' as const;
};

export const goodpayPayProcessing = (param?: string) => {
  if (param) {
    return `/${GOODPAY_MERCHANT}/pay/processing/${param}` as const;
  }
  return 'pay/processing/:id' as const;
};
